import { ReactElement } from 'react';
import { TotalItem } from 'devextreme-react/data-grid';
import React from 'react';
import { conditionalTwoDigitSummaryCurrency } from './constants/constants';

interface IDrawManualBorrowerDrawItemsProps {
    drawId: number;
    drawNumber: number;
    drawFinalized: boolean;
    needsBorrowerSignature: boolean;
    hasResubmitted: boolean;
}

export const DrawManualBorrowerDrawItems = ({
    drawId,
    drawNumber,
    drawFinalized,
    needsBorrowerSignature,
    hasResubmitted,
}: IDrawManualBorrowerDrawItemsProps): ReactElement[] => {
    if (drawFinalized) {
        return [
            <TotalItem
                name={`drawItems-funded-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
        ];
    }

    if (needsBorrowerSignature || hasResubmitted) {
        return [
            <TotalItem
                name={`drawItems-funded-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
        ];
    }

    return [
        <TotalItem
            name={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
            showInColumn={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
            summaryType='custom'
            customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
        />,
    ];
};
